import { useTranslation } from '@exam-room/translations';

import { Modal } from '../../../../components';

export default function VideoModal({
  show,
  onClose,
  videoUrl,
}: {
  show: boolean;
  onClose: () => void;
  videoUrl: string;
}) {
  const { t } = useTranslation();

  return (
    <Modal open={show} onClose={onClose} className='h-fit max-w-[960px] p-6'>
      <div className='flex size-full flex-col gap-6'>
        <h3 className='font-semibold'>{t('instruction.videoModal.title')}</h3>
        <hr className='border-border-divider' />
        <div className='mt-2 flex-1'>
          <video
            width='100%'
            height='100%'
            controls
            autoPlay
            muted
            className='h-full w-full object-contain'
          >
            <source src={videoUrl} type='video/webm' />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </Modal>
  );
}
